import { Box, Typography } from "@mui/material";
import { IStaff } from "../types/interfaces/IStaff";
import NicuStaffDetail from "./NicuStaffDetail";

//This function create staff component.
export default function NicuStaffSummary(props: {staffs: Array<IStaff>}) {

    if(props.staffs == null || props.staffs.length <= 0) return (<></>);

    return (
        <>
            <Box>
                <Typography sx={{ mt: 4, mb: 2 }} variant="h6" color="primary.dark" component="div">Staff</Typography>
            </Box>
            <Box>
                <NicuStaffDetail staffs={props.staffs} />
            </Box>
        </>
    );
}